import { configureStore } from '@reduxjs/toolkit';

import { isDev, isTest } from 'config';
import { rtkQueryError } from 'utils/fetchUtils/fetchUtils';
import { authReducer } from './authState/authState';
import { changeEmailReducer } from './changeEmailState/changeEmailState';
import { customerApi } from './customerService';
import { customerReducer } from './customerState/customerState';
import { deleteAccountReducer } from './deleteAccountState/deleteAccountState';
import { globalErrorReducer } from './globalErrorState/globalErrorState';
import { localizationReducer } from './localizationState/localizationState';
import { documentReducer } from './documentState/documentState';
import { passwordResetReducer } from './passwordResetState/passwordResetState';
import { productApi } from './productService';
import { signUpReducer } from './signupState/signupState';
import { productRegistrationReducer } from './productRegistrationState/productRegistrationState';
import { serviceApi } from './serviceService';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    changeEmail: changeEmailReducer,
    customer: customerReducer,
    deleteAccount: deleteAccountReducer,
    globalError: globalErrorReducer,
    localization: localizationReducer,
    document: documentReducer,
    passwordReset: passwordResetReducer,
    [productApi.reducerPath]: productApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [serviceApi.reducerPath]: serviceApi.reducer,
    signUp: signUpReducer,
    productRegistration: productRegistrationReducer
  },
  middleware: (getDefaultMiddleware) => {
    // Middlewares
    const middlewares = [
      productApi.middleware,
      customerApi.middleware,
      serviceApi.middleware
    ];

    if (!isTest) {
      middlewares.push(rtkQueryError);
    }

    return getDefaultMiddleware().concat(middlewares);
  },
  devTools: isDev
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
